export default __webpack_public_path__ + "static/media/results.00ca5517.png";